import React, { useState, useEffect } from "react";
import editicon from "../../../../assets/images/icons/edit.svg";
import removeicon from "../../../../assets/images/icons/remove.svg";
import searchicon from "../../../../assets/images/icons/search-normal.svg";
import { Table } from "reactstrap";
import IconButton from "../../../../assets/elements/IconButton";
import Pagination from "../../../../assets/elements/CustomPagination";
import SuccessModal from "../../../../assets/elements/SuccessModal";
import "../DepartmentMaster.scss";
import { InputGroup, Form, Button, Modal } from "react-bootstrap";
import { PrimaryInput } from "../../../../assets/FormElements";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomErrorMessage from "../../../../assets/elements/ErrorMessage";
import { squareBackIcon } from "../../../../assets/images/icons/icons";
import useCurrentPage from "../../../../hooks/useCurrentPage";
import axios from "axios";
import { notifySuccess } from "../../../../assets/elements/Toast";
import { notifyWarn } from "../../../../assets/elements/Toast";
import MainServices from "../../../../services/MainServices";
import moment from "moment";
import ButtonLoading from "../../../../assets/loaders/ButtonLoading";
import PageLoader from "../../../../assets/loaders/PageLoading";
import { useLocation, useNavigate } from "react-router-dom";
import TimingFunctions from "../../../../assets/functions/TimingFunctions";
import PermissionFunctions from "../../../../assets/functions/PermissionFunctions";
import {
    paramsToFilters,
    paramsToFiltersObj,
    filtersToUri,
    filtersToUrlParams,
} from "../../../../assets/functions/filters";
import { PrimaryButton } from "../../../../assets/buttons";
import useFeatureSetting from "../../../../hooks/useFeatureSetting";
import StatusModalContent from "../../../../assets/modal/StatusModalContent";
import editgreenicon from "../../../../assets/images/icons/edit1.svg";
import useAuth from "../../../../hooks/useAuth";
import ViewIcon from "../../../../assets/images/icons/eye-svgrepo-com.svg";
import Cross from "../../../../assets/images/icons/cross.svg";
import IsWorkflowSlug from "../../../../assets/modal/IsWorkflowSlug";
import Select from "react-select";
import CustomDigitalSignature from "../../../../assets/modal/CustomDigitalSignature";

const StatusEnum = {
    INITIATED: "initiated",
    REINITIATED: "reinitiated",
    APPROVED: "approved",
    REJECTED: "rejected",
};

const allStatus = [
    { label: "All", value: "" },
    { value: StatusEnum.INITIATED, label: "Initiated" },
    { value: StatusEnum.REINITIATED, label: "Reinitiated" },
    { value: StatusEnum.APPROVED, label: "Approved" },
    { value: StatusEnum.REJECTED, label: "Rejected" },
];

const FormatNumberMaster = () => {
    const [successModal, setSuccessModal] = useState();
    const [successType, setSuccessType] = useState();
    const [addFormatNumberModal, setAddFormatNumberModal] = useState(false);
    const [deleteFormatNumberModal, setDeleteFormatNumberModal] = useState(false);
    const { updateCurrentPage } = useCurrentPage();
    const [formatNumbersMaster, setFormatNumbersMaster] = useState([]);
    const [selectedFormatNumber, setSelectedFormatNumber] = useState({});
    const [buttonLoading, setButtonLoading] = useState(false);
    const [totalFormatNumber, setTotalFormatNumber] = useState(0);
    const [pageLoading, setPageLoading] = useState(true);
    const {
        addFormatNumbers,
        getFormatNumbersList,
        updateFormatNumbers,
        updateFormatNumbersStatus,
        getFormatNumbersById,
        getWorkflowsBySlug,
        getPlants,
    } = MainServices();
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedStatus, setSelectedStatus] = useState({ value: "all", label: "All", key: "all" });
    const location = useLocation();
    const status = new URLSearchParams(location.search).get("status");
    const navigate = useNavigate();
    const [searchString, setSearchString] = useState("");
    const [filters, setFilters] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 20,
    });
    const { deBounce } = TimingFunctions();
    const { grantPermission } = PermissionFunctions();
    const { updateSettingContext, setting } = useFeatureSetting();
    const [statusModal, setStatusModal] = useState(false);
    const { user } = useAuth();
    const [isWorkflowFlag, setIsWorkflowFlag] = useState({});
    const [workflowModal, setWorkflowModal] = useState(false);
    const [workflowDataSet, setWorkflowDataSet] = useState("");
    const [selectOptions, setSelectOptions] = useState([]);
    const [availableStatus, setAvailableStatus] = useState([]);
    const [digitalSignatureModal, setDigitalSignatureModal] = useState(false);
    const [defaultPlantName, setDefaultPlantName] = useState("");
    const [selectedPlantData, setSelectedPlantData] = useState(null);

    const formatNumberSchema = Yup.object().shape({
        name: Yup.string()
            .transform((value) => value.trim())
            .required("Name is Required"),
        formatNo: Yup.string()
            .transform((value) => value.trim())
            .required("Format Number is Required"),
        type: Yup.string()
            .transform((value) => value.trim())
            .required("Type is Required"),
        subType: Yup.string()
            .transform((value) => value.trim())
            .required("Sub Type is Required"),
    });

    const updateFormatNumberSchema = Yup.object().shape({
        name: Yup.string()
            .transform((value) => value.trim())
            .required("Name is Required"),
        formatNo: Yup.string()
            .transform((value) => value.trim())
            .required("Format Number is Required"),
        type: Yup.string()
            .transform((value) => value.trim())
            .required("Type is Required"),
        subType: Yup.string()
            .transform((value) => value.trim())
            .required("Sub Type is Required"),
        workflows: Yup.array()
            .of(
                Yup.object().shape({
                    users: Yup.array().required("users array is required"),
                })
            )
            .test("at-least-one-user", "Workflow is Required", function (workflows) {
                return workflows.some(
                    (workflow) => workflow.users && workflow.users.length > 0
                );
            }),
    });

    const deleteSchema = Yup.object().shape({
        remark: Yup.string()
            .transform((value) => value.trim())
            .required("Remarks is Required"),
    });

    const params = new URLSearchParams(location.search);
    const changedParams = Object.fromEntries(params);

    useEffect(() => {
        updateCurrentPage({
            title: "Master",
            subtitle: "Format Numbers",
        });
    }, []);

    useEffect(() => {
        updateSettingContext("format_numbers");
    }, []);

    useEffect(() => {
        if (user?.selectedPlant) {
            getPlantMasters([
                {
                    key: "publicId",
                    eq: user?.selectedPlant,
                }
            ]);
        }
    }, [user?.selectedPlant]);

    useEffect(() => {
        let filtersArray = [];

        if (changedParams?.filters) {
            try {
                const rawFilters = JSON.parse(decodeURIComponent(changedParams.filters));
                filtersArray = rawFilters;
            } catch (e) {
                console.error("Error parsing filters:", e);
                filtersArray = [];
            }
        }

        filtersArray = filtersArray.filter(
            (f) => {
                if (f.key === "searchString") {
                    return f.searchString && f.fields && f.fields.length > 0;
                }
                return true;
            }
        );

        const uniqueFilters = filtersArray.filter(
            (f, i, arr) =>
                i === arr.findIndex(
                    (x) => x.key === f.key && JSON.stringify(x) === JSON.stringify(f)
                )
        );

        setFilters(uniqueFilters);

        const page = changedParams?.page || 1;
        const limit = changedParams?.limit || 20;

        setPagination({ page, limit });

        getFormatNumberMastersByStatus({
            page,
            limit,
            filters: uniqueFilters,
        });
    }, [
        changedParams.page,
        changedParams.limit,
        changedParams.filters,
    ]);

    useEffect(() => {
        let selectOptions = [{ value: "all", label: "all", key: "all" }];
        let available = setting.available_status || [];
        available.forEach((each) => {
            selectOptions.push({ value: each, label: each, key: "status" });
        });
        let record = setting.record_status || [];
        record.forEach((each) => {
            selectOptions.push({ value: each, label: each, key: "record_status" });
        });
        let review = setting.review_status || [];
        review.forEach((each) => {
            selectOptions.push({ value: each, label: each, key: "status" });
        });

        setSelectOptions(selectOptions);
    }, [setting]);


    const getFormatNumberMastersByStatus = async ({ page, limit, filters }) => {
        setPageLoading(true);

        const details = {
            pageSize: limit || 20,
            pageNumber: page || 1,
            sorting: [{ key: "id", direction: "DESC" }],
        };
        if (filters && filters.length > 0) {
            details.filters = filters;
        }

        try {
            const res = await getFormatNumbersList(details);
            if (res?.success) {
                let data = res.data?.data || [];
                const total = res.totalCount || 0;

                setTotalFormatNumber(total);

                setFormatNumbersMaster(
                    data.map((item, index) => ({
                        ...item,
                        sNo: limit * (page - 1) + index + 1,
                    }))
                );
            } else {
                setFormatNumbersMaster([]);
                setTotalFormatNumber(0);
            }
        } catch (err) {
            console.error(err);
            setFormatNumbersMaster([]);
            setTotalFormatNumber(0);
        } finally {
            setPageLoading(false);
        }
    };

    const addFormatNumber = async (values) => {
        setButtonLoading(true);
        let workflowInfo = values?.workflows || [];
        let workflowFlag = false;
        workflowInfo =
            workflowInfo.length > 0
                ? workflowInfo.map((each) => ({
                    ...each,
                    users: each?.users?.map((user) => {
                        workflowFlag = true;
                        return {
                            value: user?.publicId,
                        };
                    }),
                    ...(each?.no_of_approvals
                        ? { no_of_approvals: each?.no_of_approvals }
                        : {
                            no_of_approvals: each?.users && each?.users.length,
                        }),
                }))
                : [];

        const details = {
            name: values.name,
            formatNo: values.formatNo,
            type: values.type,
            plantId: selectedPlantData?.publicId || user?.selectedPlant,
            subType: values.subType,
            ...(values?.remark && { remark: values?.remark }),
            ...(values?.password && { password: values?.password }),
            status: "active",
        };
        if (workflowFlag) {
            details.workflowInfo = workflowInfo;
        }
        await axios
            .all([addFormatNumbers(details)])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    let message = resData.message;
                    if (resData.success) {
                        getFormatNumberMastersByStatus({
                            page: pagination.page,
                            limit: pagination.limit,
                            filters,
                        });
                        onAddFormatNumber(false);
                        setDigitalSignatureModal(false);
                        notifySuccess("Format Number Added Successfully");
                        setButtonLoading(false);
                    } else {
                        message && notifyWarn(message);
                        setButtonLoading(false);
                    }
                } else {
                    setButtonLoading(false);
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in adding Format Number");
            });
    };

    const updateFormatNumber = async (values) => {
        setButtonLoading(true);
        let workflowInfo = values?.workflows || [];
        let workflowFlag = false;
        workflowInfo =
            workflowInfo.length > 0
                ? workflowInfo.map((each) => ({
                    ...each,
                    users: each?.users?.map((user) => {
                        workflowFlag = true;
                        return {
                            value: user?.publicId,
                        };
                    }),
                    ...(each?.no_of_approvals
                        ? { no_of_approvals: each?.no_of_approvals }
                        : {
                            no_of_approvals: each?.users && each?.users.length,
                        }),
                }))
                : [];

        const details = {
            name: values.name,
            formatNo: values.formatNo,
            type: values.type,
            plantId: selectedPlantData?.publicId || user?.selectedPlant,
            subType: values.subType,
            ...(values?.password && { password: values?.password }),
        };
        if (workflowFlag) {
            details.workflowInfo = workflowInfo;
        }

        await axios
            .all([
                updateFormatNumbers(
                    details,
                    selectedFormatNumber.publicId,
                    selectedFormatNumber.concurrencyStamp
                ),
            ])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    let message = resData?.message;
                    if (resData.success) {
                        getFormatNumberMastersByStatus({
                            page: pagination.page,
                            limit: pagination.limit,
                            filters,
                        });
                        onAddFormatNumber();
                        notifySuccess("Format Number Updated Successfully");
                        setDigitalSignatureModal(false);
                        setButtonLoading(false);
                    } else {
                        message && notifyWarn(message);
                        setButtonLoading(false);
                    }
                } else {
                    setButtonLoading(false);
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in updating Format Number");
            });
    };

    const deleteFormatNumber = async (
        { recordStatus, status, email, password, remark },
        isStatus
    ) => {
        setButtonLoading(true);
        const details = {
            status: status,
            recordStatus: recordStatus,
            ...(remark && { remark: remark }),
            ...(password && { password: password }),
        };
        await axios
            .all([
                updateFormatNumbersStatus(
                    details,
                    selectedFormatNumber.publicId,
                    selectedFormatNumber.concurrencyStamp
                ),
            ])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    let message = resData?.message;
                    if (resData.success) {
                        getFormatNumberMastersByStatus({
                            page: pagination.page,
                            limit: pagination.limit,
                            filters,
                        });
                        setDeleteFormatNumberModal(false);
                        setStatusModal(false);
                        setDigitalSignatureModal(false);
                        recordStatus === "active"
                            ? notifySuccess("Record Activated  Successfully")
                            : notifySuccess("Record Inactivated  Successfully");

                        setButtonLoading(false);
                    } else {
                        message && notifyWarn(message);
                        setButtonLoading(false);
                    }
                } else {
                    setButtonLoading(false);
                }
            })
            .catch(function (res) {
                console.log("An error occurred in deleting Format Number");
            });
    };

    const getIsWorkflowSlug = async () => {
        const details = {};
        await axios
            .all([getWorkflowsBySlug(details)])
            .then(function (res) {
                if (res[0]) {
                    let resData = res[0];
                    if (resData.success) {
                        let isWorkflow = resData?.data ? resData?.data : {};
                        isWorkflow = isWorkflow?.content
                            ? JSON.parse(isWorkflow?.content)
                            : {};
                        setIsWorkflowFlag(isWorkflow);
                    } else {
                    }
                } else {
                }
            })
            .catch(function (res) {
                console.log(res);
                console.log("An error occurred in getting workflow");
            });
    };

    const getPlantMasters = async (filters) => {
        const details = {
            filters,
        };

        let results = await getPlants(details)
            .then((res) => {
                if (res) {
                    let resData = res;
                    if (resData.success) {
                        resData = resData.data ? resData.data : [];

                        const plantName = resData?.[0]?.plantName || "";
                        const plantData = resData?.[0] || null;

                        setDefaultPlantName(plantName);
                        setSelectedPlantData(plantData);
                        return resData;
                    }
                }
            })
            .catch(function (res) {
                console.error("Error in getPlants:", res);
            });
        return results;
    };
    const onManageWorkflow = ({ values, setFieldValue }) => {
        setWorkflowDataSet({
            workflows: values?.workflows,
            setFieldValue,
        });
        setWorkflowModal((prev) => !prev);
    };

    const onAddFormatNumber = (selected) => {
        if (selected) {
            setSelectedFormatNumber(selected);
        } else {
            setSelectedFormatNumber("");
        }
        setAddFormatNumberModal(!addFormatNumberModal);
    };

    const onDeleteFormatNumber = (selected) => {
        if (selected) {
            setSelectedFormatNumber(selected);
            const availableStatuses =
                setting.record_status && setting.record_status.length > 0
                    ? setting.record_status.filter(
                        (status) => status !== selected.recordStatus
                    )
                    : [];
            setAvailableStatus(availableStatuses);
        } else {
            setSelectedFormatNumber("");
        }
        setDeleteFormatNumberModal(!deleteFormatNumberModal);
    };


    const onStatusChange = (selectedOption) => {
        const e = selectedOption || { value: "all", label: "All", key: "all" };
        const value = e.value;
        const key = e.key;

        const filterArray = Array.isArray(filters) ? filters : [];

        let cleanedFilters = filterArray.filter(
            (f) => f.key !== "status" && f.key !== "record_status"
        );
        const recordStatusRequiredStatuses = ["active", "inactive"];

        if (value !== "all") {
            if (recordStatusRequiredStatuses.includes(value)) {
                cleanedFilters.push({ key: "record_status", eq: value });
                cleanedFilters.push({ key: "status", eq: "approved" });
            } else {
                cleanedFilters.push({ key: "status", eq: value });
            }
        }

        setSelectedStatus(e);

        const mfilters = encodeURIComponent(JSON.stringify(cleanedFilters));

        const search = filtersToUrlParams({
            page: 1,
            limit: pagination.limit,
            filters: mfilters,
        });

        navigate({ search });
        setFilters(cleanedFilters);
    };



    const onPage = (page) => {
        let mfilters = encodeURIComponent(JSON.stringify(filters));
        let search = filtersToUrlParams({
            page,
            limit: pagination.limit,
            filters: mfilters,
        });
        navigate({ search });
    };

    const onRowsPerPage = (rows) => {
        let mfilters = encodeURIComponent(JSON.stringify(filters));
        let search = filtersToUrlParams({
            page: pagination.page,
            limit: rows,
            filters: mfilters,
        });
        navigate({ search });
    };


    const searchFormatNumber = (e) => {
        let raw = e?.target?.value || "";
        if (raw === " " || (searchString === "" && raw.startsWith(" "))) {
            return;
        }
        raw = raw.replace(/^\s+/, "");
        setSearchString(raw);
        deBounce(() => onSearchFilter(raw), 1000);
    };

    const createSearchStringFilter = (searchString, fields) => {
        if (!searchString || !fields || fields.length === 0) {
            return null;
        }

        const filter = {
            key: "searchString",
            searchString: searchString,
            fields: fields
        };

        return filter;
    };

    const onSearchFilter = (value) => {
        const inputValue = value.trim();
        const filterArray = Array.isArray(filters) ? filters : [];

        const cleanedFilters = filterArray.filter(
            (f) => f.key !== "searchString"
        );

        if (inputValue) {
            const searchFilter = {
                key: "searchString",
                searchString: inputValue,
                fields: [
                    "name",
                    "formatNo",
                    "type",
                    "subType",
                    "fnPlant.plantName",
                ]
            };

            cleanedFilters.push(searchFilter);
        }

        const mfilters = encodeURIComponent(JSON.stringify(cleanedFilters));

        const search = filtersToUrlParams({
            page: 1,
            limit: pagination.limit,
            filters: mfilters,
        });

        navigate({ search });
        setFilters(cleanedFilters);
    };

    const onStatusModal = (selected) => {
        if (selected) {
            setSelectedFormatNumber(selected);
        } else {
            setSelectedFormatNumber("");
        }
        setStatusModal(!statusModal);
    };

    const onDigitalSignatureModal = () => {
        setDigitalSignatureModal(!digitalSignatureModal);
    };

    return (
        <div className="admin-popular-main">
            <SuccessModal
                modal={successModal}
                setModal={setSuccessModal}
                message="Feature Service"
                type={successType}
            />

            <div className="header">
                <p className="content-header-main">
                    Format Number {pageLoading ? "" : `(${totalFormatNumber || 0})`}
                </p>
                <div className="d-flex gap-3">
                    <InputGroup style={{ width: "auto" }}>
                        <Form.Control
                            placeholder="Search"
                            aria-label="Search"
                            aria-describedby="search"
                            className="search-input-main"
                            value={searchString}
                            onChange={(e) => searchFormatNumber(e)}
                        />
                        <InputGroup.Text id="search" className="search-input-main">
                            <img src={searchicon} alt="search icon" />
                        </InputGroup.Text>
                    </InputGroup>

                    <div className="product-list-header-flex">
                        <Select
                            className="custom-status-select"
                            classNamePrefix="custom-status-select"
                            isClearable
                            placeholder="All"
                            options={selectOptions}
                            value={selectedStatus}
                            onChange={onStatusChange}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: "#00c2a8",
                                    primary75: "rgba(0,194,168,0.75)",
                                    primary50: "rgba(0,194,168,0.3)",
                                    primary25: "rgba(0,194,168,0.12)",
                                },
                            })}
                            styles={{
                                option: (base, { isSelected }) => ({
                                    ...base,
                                    color: isSelected ? "#ffffff" : "var(--text-body, #4a5568)",
                                    fontWeight: isSelected ? 700 : 500,
                                }),
                            }}
                        />
                    </div>

                    {grantPermission("FormatNumbers_write") && (
                        <IconButton
                            iconType="add"
                            title="Add Format Number"
                            onClick={() => onAddFormatNumber("")}
                        />
                    )}
                </div>
            </div>
            {pageLoading ? (
                <PageLoader />
            ) : formatNumbersMaster && formatNumbersMaster.length > 0 ? (
                <div className="content">
                    <div className="table-main">
                        <Table responsive bordered className="table table-bordered">
                            <thead className="service-table-head">
                                <tr>
                                    <th>Sr.No.</th>
                                    <th>Name</th>
                                    <th>Format Number</th>
                                    <th>Type</th>
                                    <th>Plant</th>
                                    <th>Sub Type</th>
                                    <th>Created Date</th>
                                    <th>Status</th>
                                    {(grantPermission("FormatNumbers_delete") ||
                                        grantPermission("FormatNumbers_read") ||
                                        grantPermission("FormatNumbers_update")) && <th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {formatNumbersMaster.map((each) => {
                                    return (
                                        <tr key={each.publicId}>
                                            <td>{each?.sNo}</td>
                                            <td>{each?.name || "-"}</td>
                                            <td>{each?.formatNo || "-"}</td>
                                            <td>{each?.type || "-"}</td>
                                            <td>{each?.fnPlant?.plantName || "-"}</td>                
                                            <td>{each?.subType || "-"}</td>
                                            <td>{moment(each?.createdAt).format("DD-MM-YYYY")}</td>
                                            <td>
                                                {each?.status === "approved" && each?.recordStatus ? each?.recordStatus : each?.status}
                                            </td>
                                            {(grantPermission("FormatNumbers_delete") ||
                                                grantPermission("FormatNumbers_read") ||
                                                grantPermission("FormatNumbers_update")) && (
                                                    <td className="options">
                                                        <div className="d-flex gap-2">
                                                            {grantPermission("FormatNumbers_read") && (
                                                                <div
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/format-number/details?publicId=${each.publicId}`
                                                                        )
                                                                    }
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    <img
                                                                        src={ViewIcon}
                                                                        alt="View icon"
                                                                        width="20px"
                                                                        height="20px"
                                                                    />
                                                                </div>
                                                            )}
                                                            {grantPermission("FormatNumbers_delete") &&
                                                                each?.status !== "inactive" && (
                                                                    <div
                                                                        onClick={() => onDeleteFormatNumber(each)}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <img src={removeicon} alt="Remove icon" />
                                                                    </div>
                                                                )}
                                                            {grantPermission("FormatNumbers_update") &&
                                                                (each?.status === "approved" ||
                                                                    each?.status === "rejected") &&
                                                                each?.recordStatus === "active" && (
                                                                    <div
                                                                        onClick={() => onAddFormatNumber(each)}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        <img src={editicon} alt="Edit icon" />
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </td>
                                                )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </div>
            ) : (
                <div className="no-data-found-main">No Format Numbers Found</div>
            )}
            {formatNumbersMaster && formatNumbersMaster.length > 0 && (
                <div class="custom-pagination-main">
                    <div class="card-inner">
                        <Pagination
                            totalCount={totalFormatNumber}
                            currentPage={pagination.page}
                            rowsPerPage={pagination.limit}
                            onNext={onPage}
                            onPrev={onPage}
                            onPageClick={onPage}
                            onRowsPerPage={onRowsPerPage}
                        />
                    </div>
                </div>
            )}

            <Modal
                centered
                show={addFormatNumberModal}
                onHide={onAddFormatNumber}
                className="add-department-modal-main"
                selected={selectedFormatNumber}
                size="lg"
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        {selectedFormatNumber ? "Update" : "Add"} Format Number
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="add-department-modal-body">
                    <p className="mb-4 add-department-modal-content-text">
                        Please Enter Format Number Details
                    </p>

                    <Formik
                        enableReinitialize={true}
                        initialValues={{
                            name: selectedFormatNumber?.name || "",
                            formatNo: selectedFormatNumber?.formatNo || "",
                            type: selectedFormatNumber?.type || "",
                            plant: selectedFormatNumber?.plant?.plantName || defaultPlantName || "",
                            plantId: selectedFormatNumber?.plantId || user?.selectedPlant || "",
                            subType: selectedFormatNumber?.subType || "",
                            workflow_name: selectedFormatNumber?.name || "",
                            workflows: selectedFormatNumber?.workflowData || [
                                {
                                    workflow: "reviewer",
                                    users: [],
                                    no_of_approvals: "",
                                },
                                {
                                    workflow: "approver",
                                    users: [],
                                    no_of_approvals: "",
                                },
                            ],
                            disabled:
                                selectedFormatNumber?.disabled === false ||
                                    selectedFormatNumber?.disabled === "No"
                                    ? true
                                    : false,
                        }}
                        validationSchema={
                            setting?.workflow_required === "true"
                                ? updateFormatNumberSchema
                                : formatNumberSchema
                        }
                        onSubmit={(values) => {
                            const submitValues = {
                                ...values,
                                plantId: selectedPlantData?.publicId || user?.selectedPlant,
                            };

                            if (setting.digital_signature) {
                                setSelectedFormatNumber({ ...selectedFormatNumber, ...values });
                                onDigitalSignatureModal();
                            } else {
                                selectedFormatNumber
                                    ? updateFormatNumber(values)
                                    : addFormatNumber(values);
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                        }) => (
                            <Form className="form" onSubmit={handleSubmit}>
                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="contact_number">
                                        Name
                                        <span className="required-star"> *</span>
                                    </label>
                                    <PrimaryInput
                                        placeholder="Enter Name"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.name}
                                        name="name"
                                        id="name"
                                    />
                                    <CustomErrorMessage
                                        name="name"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>

                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="contact_number">
                                        Format Number
                                        <span className="required-star"> *</span>
                                    </label>
                                    <PrimaryInput
                                        placeholder="Enter Format Number"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.formatNo}
                                        name="formatNo"
                                        id="formatNo"
                                    />
                                    <CustomErrorMessage
                                        name="formatNo"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>
                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="contact_number">
                                        Type
                                        <span className="required-star"> *</span>
                                    </label>
                                    <PrimaryInput
                                        placeholder="Enter Type"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.type}
                                        name="type"
                                        id="type"
                                    />
                                    <CustomErrorMessage
                                        name="type"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>
                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="plant">
                                        Plant
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="plant"
                                        name="plant"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.plant || ""}
                                        disabled
                                    />
                                    <CustomErrorMessage
                                        name="plantId"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>
                                <div className="form-group mt-3">
                                    <label className="form-label" htmlFor="contact_number">
                                        Sub Type
                                        <span className="required-star"> *</span>
                                    </label>
                                    <PrimaryInput
                                        placeholder="Enter Sub Type"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.subType}
                                        name="subType"
                                        id="subType"
                                    />
                                    <CustomErrorMessage
                                        name="subType"
                                        errors={errors}
                                        touched={touched}
                                    />
                                </div>

                                {isWorkflowFlag &&
                                    isWorkflowFlag?.standard_workflow === "false" &&
                                    setting?.workflow_disabled === "false" && (
                                        <>
                                            <div
                                                className="my-4"
                                                style={{ borderBottom: "1px dashed #000" }}
                                            />
                                            <div className="d-flex justify-content-between align-items-center">
                                                <p className="mb-0" style={{ fontWeight: 500 }}>
                                                    Manage Workflow :
                                                    {setting?.workflow_required === "true" && (
                                                        <span style={{ color: "#f00" }}> *</span>
                                                    )}
                                                </p>
                                                <Button
                                                    className="theme-btn-main"
                                                    style={{ padding: "11px 12px" }}
                                                    onClick={() =>
                                                        onManageWorkflow({
                                                            values,
                                                            setFieldValue,
                                                        })
                                                    }
                                                >
                                                    Manage Workflow
                                                </Button>
                                            </div>
                                            <div className="workflows-list">
                                                {values.workflows &&
                                                    values.workflows.length > 0 &&
                                                    values.workflows.map((each_work, index) => {
                                                        const options = Array.from(
                                                            {
                                                                length:
                                                                    each_work?.users &&
                                                                    each_work?.users.length > 0 &&
                                                                    each_work?.users.length,
                                                            },
                                                            (_, i) => ({
                                                                label: `${i + 1}`,
                                                                value: i + 1,
                                                            })
                                                        );

                                                        return (
                                                            <div className="each-work-flow mt-3" key={index}>
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="workflow-head">
                                                                        <span
                                                                            style={{
                                                                                textTransform: "capitalize",
                                                                            }}
                                                                        >
                                                                            {each_work.workflow}
                                                                        </span>
                                                                    </div>
                                                                    <div className="form-group mb-1 d-flex gap-2 align-items-center">
                                                                        <label
                                                                            className="form-label mb-0"
                                                                            htmlFor="category"
                                                                        >
                                                                            {`Select Number of ${each_work.workflow}`}
                                                                            <span style={{ color: "#f00" }}> *</span>
                                                                        </label>
                                                                        <div className="form-control-wrap">
                                                                            <select
                                                                                className="sop-custom-form-select"
                                                                                id={`workflows.${index}.no_of_approvals`}
                                                                                name={`workflows.${index}.no_of_approvals`}
                                                                                placeholder="Select"
                                                                                onChange={(option) => {
                                                                                    setFieldValue(
                                                                                        `workflows.${index}.no_of_approvals`,
                                                                                        option?.target.value
                                                                                    );
                                                                                }}
                                                                                onBlur={handleBlur}
                                                                                style={{
                                                                                    width: "100px",
                                                                                    fontSize: "12px",
                                                                                    padding: "6px",
                                                                                }}
                                                                            >
                                                                                <option>Select...</option>
                                                                                {options &&
                                                                                    options?.length > 0 &&
                                                                                    options.map((option) => {
                                                                                        return (
                                                                                            <option value={option.value}>
                                                                                                {option.label}
                                                                                            </option>
                                                                                        );
                                                                                    })}
                                                                            </select>
                                                                            <CustomErrorMessage
                                                                                name={`noOfApprovals_${index}`}
                                                                                errors={errors}
                                                                                touched={touched}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="users mt-2 px-3">
                                                                    {each_work.users &&
                                                                        each_work.users.length > 0 &&
                                                                        each_work.users.map((user, subI) => (
                                                                            <div
                                                                                className="each-user d-flex justify-content-between mt-2"
                                                                                key={subI}
                                                                            >
                                                                                <div>
                                                                                    <span>{subI + 1}.</span>
                                                                                    <span
                                                                                        style={{
                                                                                            textTransform: "capitalize",
                                                                                        }}
                                                                                    >
                                                                                        {user.label}
                                                                                    </span>
                                                                                </div>
                                                                                <div>
                                                                                    <img
                                                                                        alt="Cross"
                                                                                        src={Cross}
                                                                                        className="delete-topic"
                                                                                        style={{
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            let data =
                                                                                                values?.workflows || [];
                                                                                            let users =
                                                                                                data[index].users || [];
                                                                                            users = users.filter(
                                                                                                (each, i) => subI !== i
                                                                                            );
                                                                                            data[index].users = users;
                                                                                            setFieldValue("workflows", data);
                                                                                            setFieldValue(
                                                                                                `workflows.${index}.no_of_approvals`,
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                <CustomErrorMessage
                                                    name="workflows"
                                                    errors={errors}
                                                    touched={touched}
                                                />
                                            </div>
                                        </>
                                    )}

                                {!digitalSignatureModal && (
                                    <div className="mt-3">
                                        <div className="d-flex gap-2">
                                            <Button
                                                className="back-icon-btn-main"
                                                onClick={onAddFormatNumber}
                                            >
                                                <span>{squareBackIcon}</span>
                                                <span className="ms-2">Back</span>
                                            </Button>
                                            <PrimaryButton
                                                className="theme-btn-main"
                                                type="submit"
                                                title={
                                                    buttonLoading ? (
                                                        <ButtonLoading />
                                                    ) : selectedFormatNumber ? (
                                                        "Update"
                                                    ) : (
                                                        "Submit"
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>

            <Modal
                centered
                show={deleteFormatNumberModal}
                onHide={onDeleteFormatNumber}
                className="add-department-modal-main"
                selected={selectedFormatNumber}
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        Update Format Number
                    </Modal.Title>
                </Modal.Header>

                {deleteFormatNumberModal && (
                    <Modal.Body className="add-department-modal-body">
                        <p>
                            Format Number :{" "}
                            <span style={{ color: "#9d72ff", textDecoration: "underline" }}>
                                {selectedFormatNumber.name}
                            </span>
                        </p>

                        <Formik
                            initialValues={{
                                recordStatus:
                                    availableStatus.length === 1 ? availableStatus[0] : "",
                                remark: "",
                            }}
                            validationSchema={setting.digital_signature && deleteSchema}
                            onSubmit={(values) => {
                                if (setting.digital_signature) {
                                    setSelectedFormatNumber({ ...selectedFormatNumber, ...values });
                                    onDigitalSignatureModal();
                                } else {
                                    deleteFormatNumber({
                                        recordStatus: values?.recordStatus,
                                        status: selectedFormatNumber?.status,
                                        password: values?.password,
                                    });
                                }
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                            }) => (
                                <Form className="form" onSubmit={handleSubmit}>
                                    {setting.digital_signature && (
                                        <>
                                            {availableStatus.length === 1 ? (
                                                <p className="mt-3" style={{ fontWeight: 500 }}>
                                                    Do you want to change the status to "{availableStatus}
                                                    "?
                                                </p>
                                            ) : (
                                                <div className="form-group d-flex align-items-center justify-content-between mt-3 col-12">
                                                    <label className="m-1">Status</label>
                                                    <div className="w-100 mt-2">
                                                        <select
                                                            name="status"
                                                            value={values.status}
                                                            onChange={(e) => {
                                                                setFieldValue("recordStatus", e.target.value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            className="record-status-form-control form-select"
                                                        >
                                                            <option value="">Select Status</option>
                                                            {availableStatus.map((status, index) => (
                                                                <option key={index} value={status}>
                                                                    {status.charAt(0).toUpperCase() +
                                                                        status.slice(1)}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <CustomErrorMessage
                                                            errors={errors}
                                                            touched={touched}
                                                            name="status"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    <div className="form-group mt-3">
                                        <label className="mb-1" htmlFor="contact_number">
                                            Remarks
                                        </label>
                                        <div className="w-100">
                                            <textarea
                                                className="form-control employee-custom-form-control"
                                                placeholder="Remarks..."
                                                aria-label="With textarea"
                                                name="remark"
                                                id="remark"
                                                value={values.remark}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <CustomErrorMessage
                                                name="remark"
                                                errors={errors}
                                                touched={touched}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <div className="d-flex gap-2">
                                            <Button
                                                className="back-icon-btn-main"
                                                onClick={onDeleteFormatNumber}
                                            >
                                                <span>{squareBackIcon}</span>
                                                <span className="ms-2">Back</span>
                                            </Button>
                                            <PrimaryButton
                                                className="theme-btn-main"
                                                type="submit"
                                                title={buttonLoading ? <ButtonLoading /> : "Update"}
                                            />
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Modal.Body>
                )}
            </Modal>

            <Modal
                centered
                show={statusModal}
                onHide={onStatusModal}
                className="add-department-modal-main"
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        Update Status
                    </Modal.Title>
                </Modal.Header>

                {statusModal && (
                    <Modal.Body className="add-department-modal-body">
                        <StatusModalContent
                            setting={setting}
                            statusApiFunction={deleteFormatNumber}
                            onClose={onStatusModal}
                            loading={buttonLoading}
                        />
                    </Modal.Body>
                )}
            </Modal>

            <Modal
                centered
                show={workflowModal}
                onHide={() => onManageWorkflow({})}
                className="add-department-modal-main"
                size="xl"
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        Manage Workflow
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="add-department-modal-body">
                    <IsWorkflowSlug
                        onManageWorkflow={() => onManageWorkflow({})}
                        workflowDataSet={workflowDataSet}
                    />
                </Modal.Body>
            </Modal>

            <Modal
                centered
                show={digitalSignatureModal}
                onHide={onDigitalSignatureModal}
                className="add-department-modal-main"
                size="md"
            >
                <Modal.Header closeButton className="add-department-modal-header">
                    <Modal.Title className="add-department-modal-title">
                        E - Signature
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="add-department-modal-body">
                    <CustomDigitalSignature
                        digitalSignatureHandleSubmit={
                            addFormatNumberModal
                                ? (selectedFormatNumber.publicId ? updateFormatNumber : addFormatNumber)
                                : deleteFormatNumber
                        }
                        onDigitalSignatureModal={onDigitalSignatureModal}
                        values={selectedFormatNumber}
                        isLoading={buttonLoading}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default FormatNumberMaster;